import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { ItemDto } from "src/dtos/item/itemDto";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from '../../../../store/useCommonCodeStore';
import { defaultKSK1090_R01Filter, useKSK1090_R01Store } from "./Store_KSK1090_R01";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import {  SearchSpacer } from "src/components/common/common";
import { CompanyDto } from "src/dtos/company/companyDto";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { searchCustomer } from "src/apis/customerApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";

export const SearchSection_KSK1090_R01 = () => {
    const {KSK1090_R01Filter,setKSK1090_R01Filter } = useKSK1090_R01Store();
    const { brandCdList,compCdList,wmsCdList,wmsInTypeCdList,itemGroupList } = useCommonCodeStore();
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
    const { setCodeSearchModalProps } = useUiuxStore();

	const customCdHandleFoucsId = 'customCd_search';
	const itemCdHandleFoucsId = 'itemCd_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
			category: '품목코드',
			focusId: itemCdHandleFoucsId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			extraFilter: () => ({
				itemCd: KSK1090_R01Filter.itemCd || '',
				itemNm: KSK1090_R01Filter.itemNm || '',
			}),
		},
		{
            fieldName: 'customCd',
            category: '거래처',
            focusId: customCdHandleFoucsId,
            responseMapping: {
                customCd: 'customCd',
                customNm: 'customNm',
            },
            searchFunction: async (searchText: string) => {
                const customerResponse = await searchCustomer(searchText);
                return customerResponse.data.data.find(value => value.customCd === searchText);
            },
			extraFilter: () => ({
				customCd: KSK1090_R01Filter.customCd || '',
				customNm: KSK1090_R01Filter.customNm || '',
			}),
        },
	];
	
    // Info 폼 이벤트 훅 사용
    const { getFieldHandlers } = useInfoFormEvents({
        editData: KSK1090_R01Filter,
        setEditData: setKSK1090_R01Filter,
        defaultData: defaultKSK1090_R01Filter,
        infoFieldConfigs,
        setCodeSearchModalProps,
        formName: 'SAL2060_R01_search'
    });

	const customCdModalWrapperOption = {
		wrapperStyle: "w-[550px] min-w-[550px] mr-[10px]",
		titleStyle: "w-[55px] min-w-[55px] text-left",
		codeInputStyle: "w-[190px] min-w-[190px]",
		nameTagStyle: "w-[300px] min-w-[300px] text-left",
	};

	const itemCdModalWrapperOption = {
		wrapperStyle: "w-[600px] min-w-[600px] mr-[10px]",
		titleStyle: "w-[80px] min-w-[80px] text-left",
		codeInputStyle: "w-[190px] min-w-[190px]",
		nameTagStyle: "w-[300px] min-w-[300px] text-left",
	};

    return (
        <div className="w-full ">
            <SearchSectionDoubleForm >
                <SearchDropDownForm<CompanyDto>
                    label="사업장"
                    value={KSK1090_R01Filter.compCd}
                    optionList={compCdList}
                    onChangeValue={v => setKSK1090_R01Filter({ compCd: v === 'all' ? '' : v })}
                />
                <SearchDateRangeForm
                    label="입고기간"
                    visible={pickerVisible}
                    setVisible={setPickerVisible}
                    dateRange={KSK1090_R01Filter.transportDt}
                    setDateRange={v => setKSK1090_R01Filter({ transportDt: v })}
                    pickerPosition={pickerPosition}
                    setPickerPosition={setPickerPosition}
                />
                <SearchDropDownForm<SysCodeDto>
                    label="입고분류"
                    value={KSK1090_R01Filter.inoutClass}
                    optionList={wmsInTypeCdList}
                    onChangeValue={v => setKSK1090_R01Filter({ inoutClass: v === 'all' ? '' : v })}
                />
                <SearchDropDownForm<SysCodeDto>
                    label="창고코드"
                    value={KSK1090_R01Filter.logicCenter}
                    optionList={wmsCdList}
                    onChangeValue={v => setKSK1090_R01Filter({ logicCenter: v === 'all' ? '' : v })}
                />
                <SearchSpacer/>
                <SearchCodeModalForm
                    label="거래처"
                    value={KSK1090_R01Filter.customCd}
                    valueLabel={KSK1090_R01Filter.customNm}
					handleFoucsId={customCdHandleFoucsId}
                    onChange={getFieldHandlers('customCd').onChange}
                    onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
					wrapperOption={customCdModalWrapperOption}
                />
                <SearchCodeModalForm
                    label="품목코드"
                    value={KSK1090_R01Filter.itemCd}
                    valueLabel={KSK1090_R01Filter.itemNm}
					handleFoucsId={itemCdHandleFoucsId}
                    onChange={getFieldHandlers('itemCd').onChange}
                    onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
					wrapperOption={itemCdModalWrapperOption}
                />
                <SearchDropDownForm<SysCodeDto>
                    label="품목그룹"
                    value={KSK1090_R01Filter.itemGroup}
                    optionList={itemGroupList}
                    onChangeValue={v => setKSK1090_R01Filter({ itemGroup: v === 'all' ? '' : v })}
                />
                <SearchDropDownForm<SysCodeDto>
                    label="브랜드"
                    value={KSK1090_R01Filter.brandCd}
                    optionList={brandCdList}
                    onChangeValue={v => setKSK1090_R01Filter({ brandCd: v === 'all' ? '' : v })}
                />
            </SearchSectionDoubleForm>
        </div>
    );
};


